var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    viewBox: "0 0 61.552 39.231",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.161 18.418C60.611 17.666 47.509 0 30.776 0S.94 17.665.391 18.417a2.031 2.031 0 000 2.4c.549.752 13.652 18.418 30.385 18.418s29.835-17.67 30.385-18.422a2.029 2.029 0 000-2.395zM30.776 35.172c-12.326 0-23-11.725-26.162-15.558C7.77 15.778 18.423 4.058 30.776 4.058c12.325 0 23 11.723 26.162 15.558-3.157 3.837-13.81 15.556-26.162 15.556z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.779 7.44a12.175 12.175 0 1012.172 12.175A12.189 12.189 0 0030.779 7.44zm0 20.292a8.117 8.117 0 118.117-8.117 8.126 8.126 0 01-8.117 8.117z"
  }))));
}

export default SvgEye;